import { KeycloakProfile } from "../redux/reducers/auth";

export const DISTRIBUTOR_ROLE = 'DISTRIBUTOR'

export const isDistributorUser = (user: KeycloakProfile | null) => {
  return !!user && !!user.roles && user.roles.includes(DISTRIBUTOR_ROLE)
}
